import CreatePasswordRequest from '../entities/CreatePasswordRequest'
import CreatePasswordResponse from '../entities/CreatePasswordResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface ICreatePassword {
  execute(params: CreatePasswordRequest): Promise<CreatePasswordResponse>
}

export default class CreatePasswordImpl implements ICreatePassword {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(
    params: CreatePasswordRequest,
  ): Promise<CreatePasswordResponse> {
    const response = await this.userRepository.createPassword(params)

    return response
  }
}
